const fr_FR = {
  Name: 'Nom'
};

export default fr_FR;
